module.exports = __webpack_public_path__ + "img/logo.720e886e.png";